import { render } from "./OutOfLeads.vue?vue&type=template&id=408b9e78&scoped=true&ts=true"
import script from "./OutOfLeads.vue?vue&type=script&lang=ts"
export * from "./OutOfLeads.vue?vue&type=script&lang=ts"

import "./OutOfLeads.vue?vue&type=style&index=0&id=408b9e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408b9e78"]])

export default __exports__